// assumed to be in "px"
export const SIZE_SUB_UNIT = 4

export const SIZE_UNIT = 8

export const GUTTER_HEIGHT = 8
